import { TileVM, TileParent } from './tile-vm';
import { Tile } from '@/core/models/tile';
import { TileType } from './tile-type';

// TODO this is not a model, should be relocated
export class TileVmMapper {
    static getParentSort(parents: TileParent[]): string {
        if (!parents || parents.length === 0) {
            return '';
        }
        return parents.map((parent) => parent.name).join(', ');
    }

    static map(tile: Tile, allTiles: Tile[]): TileVM {
        const parents: TileParent[] = (tile.parents ?? []).map((t) => {
            return {
                id: t,
                name: allTiles.filter((at) => at.id === t)[0]?.name ?? '',
            };
        });

        return {
            id: tile.id,
            name: tile.name,
            archived: tile.archived,
            favorite: tile.favorite,
            type: tile.type,
            layer: tile.layer,
            description: tile.description,
            customData: tile.customData,
            externalRefs: tile.externalRefs,
            children: tile.children,
            parents,
            parentSort: TileVmMapper.getParentSort(parents),
            color: tile.color.slice(0, -2),
            isChecked: false,
            isAvailableToAllUsers: tile.isAvailableToAllUsers,
            assignedGroups: tile.assignedGroups,
            assignedUsers: tile.assignedUsers,
        };
    }

    static mapToDto(tile: TileVM): Tile {
        let parents: number[] = (tile.parents ?? []).map((t) => t.id);
        parents = tile.type === TileType.Global ? [] : parents;
        return {
            id: tile.id,
            name: tile.name,
            archived: tile.archived,
            favorite: tile.favorite,
            type: tile.type,
            layer: tile.layer,
            description: tile.description,
            children: tile.children,
            parents,
            color: tile.color.length === 7 ? tile.color + 'ff' : tile.color,
            isAvailableToAllUsers: tile.isAvailableToAllUsers,
            assignedGroups: tile.assignedGroups,
            assignedUsers: tile.assignedUsers,
        };
    }

    static newTileVm(): TileVM {
        return {
            id: 0,
            name: '',
            archived: false,
            favorite: false,
            type: TileType.Normal,
            layer: 0,
            description: '',
            children: [],
            parents: [],
            parentSort: '',
            color: '#64bef8',
            isChecked: false,
            isAvailableToAllUsers: true,
            assignedGroups: [],
            assignedUsers: [],
        };
    }
}
